import { cn } from "@/lib/utils";
import Image from "next/image";
import logo from "public/logo.png";
import type { ComponentProps } from "react";

export interface Props
  extends Omit<ComponentProps<typeof Image>, "alt" | "src"> {}

export default function Logo({ ...props }: Props) {
  return (
    <Image
      width={190}
      height={42}
      className={cn("max-w-[150px] sm:max-w-[200px]", props.className)}
      draggable={false}
      {...props}
      src={logo}
      alt={"Joy Awards"}
    />
  );
}
